import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const setPostHideFromFeed = async ({ postId, hideFromFeed }) => {
	try {
		const postDocRef = firestore.collection('posts').doc(postId)
		return await postDocRef.set({ hideFromFeed, modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp() }, { merge: true })
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, { postId }, exception)
	}
}

export default setPostHideFromFeed



// WEBPACK FOOTER //
// ./src/dataservices/setPostHideFromFeed.js